import { Col, Container, Row } from "react-bootstrap";
import one from "../../../assets/images/about11.png";
import two from "../../../assets/images/about2.png";
import three from "../../../assets/images/about3.png";
import four from "../../../assets/images/about4.png";
import five from "../../../assets/images/about5.png";
import six from "../../../assets/images/about6.png";
import styles from "../features/feature.module.scss";
import line from "../../../assets/images/line.png";
const Feature = () => {
  return (
    <Container>
      <div className={styles.mainWrapper}>
        <div className={styles.head}>
          <p>
            {" "}
            <img src={line} /> Easy to use <img src={line} />
          </p>
          <span>Product Features</span>
        </div>
        <Row>
          <Col sm={12} md={12} lg={6}>
            <div className={styles.main_cardOne}>
              <div className={styles.main_img}>
                <img src={one} />
              </div>
              <div className={styles.text}>
                <p>Effortless Scheduling On the Go:</p>
                <span>
                  <ul>
                    <li>Simplified scheduling process.</li>
                    <li>
                      In-app follow-ups and reminders to streamline your
                      workflow.
                    </li>
                    <li>User-friendly interface for a seamless experience.</li>
                  </ul>
                </span>
              </div>
            </div>
          </Col>
          <Col
            className="d-flex align-items-center justify-content-center"
            sm={12}
            md={12}
            lg={6}
          >
            {" "}
            <div className={styles.main_card}>
              <div className={styles.main_img}>
                <img src={two} />
              </div>
              <div className={styles.text}>
                <p>Transparent Monitoring for All:</p>
                <span>
                  <ul>
                    <li>
                      Whether you're a township or a contractor/builder, CID
                      provides the transparency you need to efficiently manage
                      your operations.
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </Col>
          <Col sm={12} md={12} lg={6}>
            {" "}
            <div className={styles.main_cardOne}>
              <div className={styles.main_img}>
                <img src={three} />
              </div>
              <div className={styles.text}>
                <p>Access to Certified Inspectors:</p>
                <span>
                  <ul>
                    <li>
                      Connect with qualified and certified inspectors to ensure
                      thorough and reliable inspections.
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </Col>
          <Col
            className="d-flex align-items-center justify-content-center"
            sm={12}
            md={12}
            lg={6}
          >
            {" "}
            <div className={styles.main_card}>
              <div className={styles.main_img}>
                <img src={four} />
              </div>
              <div className={styles.text}>
                <p>Data-Driven Decision Making:</p>
                <span>
                  <ul>
                    <li>
                      Gain a 360-degree view of all data for making informed
                      decisions, focusing on quality checks and compliance.
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </Col>
          <Col sm={12} md={12} lg={6}>
            {" "}
            <div className={styles.main_cardOne}>
              <div className={styles.main_img}>
                <img src={five} />
              </div>
              <div className={styles.text}>
                <p>Proprietary Algorithm for Inspector Matching:</p>
                <span>
                  <ul>
                    <li>
                      Our advanced algorithm ensures conflict-free assignment of
                      inspectors, prioritizing compliance and safety.
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </Col>
          <Col
            className="d-flex align-items-center justify-content-center"
            sm={12}
            md={12}
            lg={6}
          >
            {" "}
            <div className={styles.main_card}>
              <div className={styles.main_img}>
                <img src={six} />
              </div>
              <div className={styles.text}>
                <p>Effortless Record Keeping:</p>
                <span>
                  <ul>
                    <li>
                      Hassle-free digital record-keeping to manage all
                      communication and documents related to your
                      property/properties.
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};
export default Feature;
